<template>
  <div id="progreso">
    <router-link
      to="/progreso"
      class="miperfil abs pointer"
      data-aos="fade-right"
      data-aos-delay="200"
    >
      <img
        src="../../../assets/imgs/mision/btn-mi-perfil.png"
        alt="Encauce"
        class="img-fluid w-100"
      />
    </router-link>

    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="pregunta abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/bg-pregunta-trapezoide.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div
                class="pregunta_txt abs"
                data-aos="fade-up"
                data-aos-delay="200"
              >
                <div class="bold">
                  <span class="azulclaro">NIVEL 01 - </span>
                  <span class="electrico">CUESTIONARIO</span>
                </div>
              </div>
            </div>

            <div class="quasar abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/mision/quasar-verde.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div
              v-if="resultado != null"
              class="info abs"
              data-aos="zoom-in"
              data-aos-delay="400"
            >
              <div class="row">
                <div class="col-12">
                  <div class="tarjeta bggradazul">
                    <div class="grid fpG1 bold">
                      <form
                        class="cuestionario py3"
                        action=""
                        @submit="avanzar"
                      >
                        <div class="pb4">
                          <span class="electrico fpXG2">
                            1. ¿Te sientes identificado(a) con los resultados
                            que arrojó este nivel?
                          </span>
                          <div class="pt5 fpXG blanco">
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta1"
                                value="Muy identificado(a)"
                              />
                              Muy identificado(a)
                            </label>
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta1"
                                value="Identificado(a)"
                              />
                              Identificado(a)</label
                            >
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta1"
                                value="Poco identificado(a)"
                              />
                              Poco identificado(a)</label
                            >
                          </div>
                        </div>

                        <hr />

                        <!-- <div class="pb4">
                          <span class="electrico fpXG2">
                            2. Cuéntanos por qué:
                          </span>
                          <div class="pt5 fpXG azuloscuro">
                            <label class="d-flex pb3">
                              <textarea
                                rows="2"
                                maxlength="1000"
                                class="blanco"
                                type="text"
                                v-model="form.pregunta2"

                              >
                              </textarea>
                            </label>
                          </div>
                        </div>

                         <hr> -->

                        <div class="pb4">
                          <span class="electrico fpXG2">
                            2. ¿Los retos dentro de las misiones te resultaron?
                          </span>
                          <div class="pt5 fpXG blanco">
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta3"
                                value="Muy identificado(a)"
                              />
                              Fáciles
                            </label>
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta3"
                                value="Identificado(a)"
                              />
                              Complicados</label
                            >
                          </div>
                        </div>

                        <hr />

                        <!-- <div class="pb4">
                          <span class="electrico fpXG2">
                            4. Cuéntanos por qué:
                          </span>
                          <div class="fpXG azuloscuro pt5">
                            <label class="d-flex pb3">
                              <textarea
                                rows="2"
                                maxlength="1000"
                                class="blanco"
                                type="text"
                                v-model="form.pregunta4"
                              >
                              </textarea>
                            </label>
                          </div>
                        </div>

                        <hr /> -->

                        <div class="pb4">
                          <span class="electrico fpXG2">
                            3. Las instrucciones para resolver las
                            misiones/retos son:
                          </span>
                          <div class="pt5 fpXG blanco">
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta5"
                                value="Claras"
                              />
                              Claras
                            </label>
                            <label class="d-flex pb3"
                              ><input
                                class="mr4"
                                type="radio"
                                v-model="form.pregunta5"
                                value="Confusas"
                              />
                              Confusas</label
                            >
                          </div>
                        </div>

                        <div class="w-100 text-right">
                          <div class="cont-btn-sig btn-avanzar pb6">
                            <button type="submit" class="btn-sig mb5">
                              <span class="texto">
                                <span class="bold">CONTINUAR</span>
                              </span>
                              <img
                                class="icono"
                                src="../../../assets/imgs/mision/cohete.png"
                                alt="icono"
                              />
                              <span class="flecha">
                                <img
                                  src="../../../assets/imgs/mision/flecha-sig3.png"
                                  alt="icono"
                                />
                              </span>
                            </button>
                            <div class="flecha2">
                              <img
                                src="../../../assets/imgs/mision/flecha-sig2.png"
                                alt="icono"
                              />
                            </div>
                            <div class="flecha1">
                              <img
                                src="../../../assets/imgs/mision/flecha-sig1.png"
                                alt="icono"
                              />
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";
import router from "../../../router/index";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      settings: {
        personaje: null,
        mision: 1,
      },
      mision: 1,
      avance: [],
      resultado: null,
      habilidades: {},
      barras: {
        habilidad_0: "0%",
        habilidad_1: "0%",
        habilidad_2: "0%",
        habilidad_3: "0%",
      },
      resultados: {
        acomodador: {
          nombre: "Acomodador",
          gadget: "Cinturón galáctico",
        },
        asimilador: {
          nombre: "Asimilador",
          gadget: "Goggles galáctico",
        },
        convergente: {
          nombre: "Convergente",
          gadget: "Casco galáctico",
        },
        divergente: {
          nombre: "Divergente",
          gadget: "Guantes galácticos",
        },
      },
      form: {
        mision: 1,
        pregunta1: "",
        pregunta2: "",
        pregunta3: "",
        pregunta4: "",
        pregunta5: "",
      },
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.getAvance();
  },
  methods: {
    async getAvance() {
      let vm = this;
      this.avance = await this.$store.dispatch("getAvance");
      console.log({ avance: this.avance });
      console.log({ mision: this.mision - 1 });
      console.log(this.avance.misiones[this.mision - 1].resultado_evaluacion);
      this.resultado = this.avance.misiones[
        this.mision - 1
      ].resultado_evaluacion;

      this.habilidades = this.avance.misiones[this.mision - 1].habilidades;

      setTimeout(function () {
        vm.calculaBarras();
      }, 1500);
    },
    calculaBarras() {
      let multiplicador = 200;
      let total =
        this.habilidades.habilidad_0 +
        this.habilidades.habilidad_1 +
        this.habilidades.habilidad_2 +
        this.habilidades.habilidad_3;

      this.barras.habilidad_0 =
        (this.habilidades.habilidad_0 / total) * multiplicador;
      this.barras.habilidad_1 =
        (this.habilidades.habilidad_1 / total) * multiplicador;
      this.barras.habilidad_2 =
        (this.habilidades.habilidad_2 / total) * multiplicador;
      this.barras.habilidad_3 =
        (this.habilidades.habilidad_3 / total) * multiplicador;

      this.barras.habilidad_0 = this.barras.habilidad_0 + "%";
      this.barras.habilidad_1 = this.barras.habilidad_1 + "%";
      this.barras.habilidad_2 = this.barras.habilidad_2 + "%";
      this.barras.habilidad_3 = this.barras.habilidad_3 + "%";
    },
    selecciona(mision) {
      router.push("/mision-" + mision + "-intro");
    },
    async avanzar(e) {
      e.preventDefault();

      if (
        this.form.pregunta1 == "" ||
        //this.form.pregunta2 == "" ||
        this.form.pregunta3 == "" ||
        //this.form.pregunta4 == "" ||
        this.form.pregunta5 == ""
      ) {
        swal.fire(
          "Oops",
          "Responde todos los campos antes de continuar...",
          "warning"
        );
        return;
      }

      await this.$store.dispatch("registroCuestionario", this.form);

      router.push("/mision-" + (this.mision + 1) + "-intro");
      //this.$router.push("/resultados/descarga");
    },
    toggleInfo() {},
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
#progreso {
  background: url(../../../assets/imgs/resultados/bg-resultados.jpg) no-repeat;
  background-size: cover;
  background-position: bottom right;
  .contentabs {
    .logo {
      bottom: 5%;
      left: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      right: 8%;
      width: 20%;
      position: absolute;
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
      .gadget {
        position: absolute;

        img {
          width: 100%;
        }
        &.acomodador {
          top: 37%;
          width: 37.4%;
          left: 23%;
        }
        &.asimilador {
          top: 4%;
          width: 28.4%;
          left: 25%;
        }
        &.convergente {
          top: -0.5%;
          width: 33.4%;
          left: 22%;
        }
        &.divergente {
          top: 37%;
          width: 66.4%;
          left: 9%;
        }
      }
    }

    .pregunta {
      top: 0%;
      left: 8%;
      width: 72%;
      position: fixed;
      z-index: 10000;
      .pregunta_txt {
        top: 50%;
        transform: translateY(-50%);
        left: 0%;
        width: 70%;
        margin: 0 0 0 20%;
        position: absolute;
        div {
          font-size: 1.2vw;
        }
      }
    }
    .quasar {
      z-index: 100000 !important;
      top: 4.3%;
      left: 13%;
      width: 7%;
      position: fixed;
      animation: float 6s ease-in-out infinite;
      z-index: 100;
    }

    .info {
      width: 94%;
      top: 25%;
      left: 3%;
      img {
      }
    }
    .resultado_mision {
      width: 70%;
      top: 25%;
      left: 3%;
      img {
        width: auto !important;
      }
    }

    .botonera {
      width: 40%;
      top: 13%;
      left: 54%;
      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: relative;
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        right: 5%;
        width: 23%;
      }
    }
  }

  .tarjeta {
    width: 100%;

    border-radius: 15px;
    padding: 1vw 2vw;
    .grid {
      .barra {
        height: 1vw;
        width: 0%;
        -webkit-border-top-right-radius: 2vw;
        -webkit-border-bottom-right-radius: 2vw;
        -moz-border-radius-topright: 2vw;
        -moz-border-radius-bottomright: 2vw;
        border-top-right-radius: 2vw;
        border-bottom-right-radius: 2vw;
        transition: 0.5s all ease-out;
      }
    }

    .gadget {
      img {
        width: 100% !important;
      }
    }
  }

  .pantalla {
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .cont-btn-sig .btn-sig {
    float: none;
  }
}
</style>
